import { Component } from "@angular/core";

@Component({
    selector : 'cp-footer',
    templateUrl : './footer.component.html',
    styleUrls : ['./footer.component.less']
})

export class FooterComponent{

    calenderYear: number = new Date().getFullYear();
    constructor(){

    }

    ngOnInit(): void {
        
    }
}